import { useEffect, useState } from "react";
import RouteList from "./routes";

const App = () => {
  const [deviceWidth, setDeviceWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setDeviceWidth(window.innerWidth);
    };

    // Add event listener to update device width on resize
    window.addEventListener("resize", handleResize);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {deviceWidth > 640 ? (
        <>
          <RouteList />
        </>
      ) : (
        <div className="flex justify-center items-center h-screen text-red-500">
          Not supported on small devices.
        </div>
      )}
    </>
  );
};

export default App;
